import type { ReactNode } from 'react'

/** Modul-lokale Klartext-Chips (Typ, Modul, Checklisten-Name, „fehlt“) mit festem Farbton. */
const CHIP = 'inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-medium'

const TYP: Record<string, { label: string; klasse: string }> = {
  EINSATZ: { label: 'Einsatz', klasse: 'border-orange-500/40 bg-orange-500/15 text-orange-200' },
  UEBUNG: { label: 'Übung', klasse: 'border-emerald-500/30 bg-emerald-500/10 text-emerald-200' },
  UEBUNGSEINSATZ: { label: 'Übungseinsatz', klasse: 'border-violet-500/30 bg-violet-500/10 text-violet-200' },
}
const MODUL: Record<string, { label: string; klasse: string }> = {
  FUEHRUNG: { label: 'Führung', klasse: 'border-sky-500/30 bg-sky-500/10 text-sky-200' },
  PILOT: { label: 'Pilot', klasse: 'border-teal-500/30 bg-teal-500/10 text-teal-200' },
}
const NEUTRAL = 'border-dark-border bg-dark-bg-tertiary text-dark-text-muted'

export const typLabel = (t?: string | null) => (t ? TYP[t]?.label ?? t : '—')
export const modulLabel = (m?: string | null) => (m ? MODUL[m]?.label ?? m : '—')

export function TypChip({ typ }: { typ?: string | null }) {
  if (!typ) return <Leer />
  return <span className={`${CHIP} ${TYP[typ]?.klasse ?? NEUTRAL}`}>{typLabel(typ)}</span>
}
export function ModulChip({ modul }: { modul?: string | null }) {
  if (!modul) return <Leer />
  return <span className={`${CHIP} ${MODUL[modul]?.klasse ?? NEUTRAL}`}>{modulLabel(modul)}</span>
}
/** Modul-Chip + Phase, z. B. „Pilot · Vorflug“. */
export function ChecklistenChip({ modul, phase }: { modul?: string | null; phase: string }) {
  return <span className={`${CHIP} ${MODUL[modul ?? '']?.klasse ?? NEUTRAL}`}>{modulLabel(modul)} · {phase}</span>
}
/** Gelber Hinweis-Chip für fehlende Pflichtangaben. */
export function FehltChip({ children = 'fehlt', title }: { children?: ReactNode; title?: string }) {
  return <span title={title} className={`${CHIP} border-amber-500/40 bg-amber-500/10 text-amber-200`}>{children}</span>
}
export function Leer() {
  return <span className="text-dark-text-subtle/60" aria-label="keine Angabe">–</span>
}
